export default function isValidBase(base: number): boolean {
  return base >= 2 && base <= 36
}
